import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const assetLogsSlice = createSlice({
  name: 'assetLogs',
  initialState: {
    streamsData: {},
    taskStatus: {},
    loading: {},
    activeTab: 'streams',
  },
  reducers: {
    setStreamsData: (state, action: PayloadAction<object>) => {
      state.streamsData = action?.payload
    },
    setTaskStatus: (state, action: PayloadAction<object>) => {
      state.taskStatus = action?.payload
    },
    isLoading: (state, action) => {
      state.loading = {
        ...state.loading,
        ...action?.payload,
      }
    },
    setActiveTab: (state, action) => {
      state.activeTab = action?.payload
    },
  },
})

export const { setStreamsData, setTaskStatus, isLoading, setActiveTab } =
  assetLogsSlice.actions

export default assetLogsSlice.reducer
